var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{key:_vm.column.ColumnName,class:_vm.column.class,staticStyle:{"word-break":"break-all"}},[_vm._v(" "+_vm._s(_vm._f("checkFilter")(_vm.item[_vm.column.ColumnName],_vm.column.filter))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }